import { COMPANY_PRIVACY_POLICY, COMPANY_TERMS_CONDITIONS } from '../../api';

export const LEGAL_POLICY_CONFIG = {
  privacy: {
    documentType: 'privacy-policy',
    title: 'Privacy Policy',
    defaultTitle: 'CLEANY PRO PRIVACY POLICY',
    endpoint: COMPANY_PRIVACY_POLICY,
    dashboardPath: '/dashboard/privacy-policy',
    previewPath: '/dashboard/privacy-policy/preview',
    publicPath: 'privacy-policy',
  },
  terms: {
    documentType: 'terms-conditions',
    title: 'Terms & Conditions',
    defaultTitle: 'Cleany Pro App Terms of Service',
    endpoint: COMPANY_TERMS_CONDITIONS,
    dashboardPath: '/dashboard/terms-and-conditions',
    previewPath: '/dashboard/terms-and-conditions/preview',
    publicPath: 'terms-and-conditions',
  },
};

export const getLegalPolicyConfig = (policyType) => LEGAL_POLICY_CONFIG[policyType];
